import React from 'react';
import AsyncSidebarAssetsReports from '@atlassian/jira-navigation-apps-sidebar-assets-reports/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { assetsDashboardsDetailRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsDashboardsDetailRoute.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { DashboardEditable } from '@atlassian/jira-insight-reports-v2/src/ui/dashboard-editable/index.tsx';
import { isMainGateEnabled } from '@atlassian/jira-insight-reports-v2/src/common/feature-gate-helpers.tsx';
import { AssetsAppBase } from '@atlassian/jira-spa-assets-app-base/src/ui/index.tsx';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { Redirect } from '@atlassian/react-resource-router';

const DashboardsDetailPage = () => (
	<AssetsAppBase appName={APP_NAMES.INSIGHT_ASSETS_REPORTS}>
		{({ workspaceId }) => <DashboardEditable workspaceId={workspaceId} />}
	</AssetsAppBase>
);

export const assetsDashboardsDetailRouteEntry = createEntry(assetsDashboardsDetailRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: Spinner,
	component: isMainGateEnabled()
		? DashboardsDetailPage
		: () => <Redirect to="/jira/assets/reports" />,
	resources: [...getAssetsAppResources(), ...getServicedeskPageContextResources()],
	forPaint: [LazyAssetsLayout],

	navigation: {
		sidebar: AsyncSidebarAssetsReports,
	},

	bifrost: {
		bifrostGroup: 'shell-only',
		bundling: {
			packageName:
				'@atlassian/jira-router-routes-assets-entries/src/assetsDashboardsDetailRouteEntry.tsx',
			whichExportToUse: 'assetsDashboardsDetailRouteEntry',
		},
		enabled: true,
	},
}));
